import React from "react";
import styled from "styled-components";
import SearchFieldBtn from "../../Common/Components/SearchFieldBtn";

function EmptyTabInfoTwo(props) {
  const { placeholder, description, btnText, handleOnboardSearch, handleResetInput } = props;
  return (
    <WrapperStyle>
      <div className="inner-wrapper">
        <p className="description">{description}</p>
        <SearchFieldBtn placeholder={placeholder} btnText={btnText} handleResetInput={handleResetInput} onClick={handleOnboardSearch} />
      </div>
    </WrapperStyle>
  );
}

export default EmptyTabInfoTwo;

const WrapperStyle = styled.div`
  display: flex;
  justify-content: center;
  .inner-wrapper {
    width: 80%;
    .description {
      font-size: 40px;
      color: #424b50;
      line-height: 1.175;
      font-family: 'Roboto Slab', serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 26px;
      }
    }
  }
`;
